module.exports = __webpack_public_path__ + "Lato-Regular.27bd77b9162d388cb8d4.woff";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/Lato/fonts/Lato-Regular.woff
// module id = ../../../../../src/assets/fonts/Lato/fonts/Lato-Regular.woff
// module chunks = styles